import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { BlacklistOptionsBase } from './BlacklistOptions'

import { modalActions } from 'reduxModules/actions/ModalActions'
import { blacklistBookingsSelector, isLoadingSelector } from 'reduxModules/selectors/BlacklistSelectors'
import { blacklistActions } from 'reduxModules/actions/BlacklistActions'

const mapStateToProps = createStructuredSelector({
  isLoading: isLoadingSelector,
  blacklistBookings: blacklistBookingsSelector,
})

const mapDispatchToProps = {
  showModal: modalActions.showModal,
  getBlacklistBookings: blacklistActions.getBlacklistBookings,
  deleteBlacklistPassenger: blacklistActions.deleteBlacklistPassenger
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps)
)

export const BlacklistOptions = enhance(BlacklistOptionsBase)




// WEBPACK FOOTER //
// ./src/components/BlacklistOptions/index.js